// extracted by mini-css-extract-plugin
export var line = "sso-divider-module--line--8c658";
export var message = "sso-divider-module--message--7ce2f";
export var root = "sso-divider-module--root--b519e";